import { useState } from 'react';

const useInvoiceSorting = ({ onUpdate }) => {
  const [{ sortBy, sortDirection }, setSort] = useState({ sortBy: 'updated_at', sortDirection: 'desc' });
  return {
    sortBy,
    sortDirection,
    setSort: (sort) => {
      setSort(sort);
      onUpdate();
    },
  };
};

export default useInvoiceSorting;
